import { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { useCampaignJoin } from 'context/CampaignJoin';
import useCustomTheme from 'hooks/useCustomTheme';
import NotFoundPage from 'pages/404';
import WorkflowLayout from './WorkflowLayout';

const CampaignCheckoutLayout = ({ title, children }) => {
  const router = useRouter();
  const { campaign, routes, modules, loading, onNavigate, resetFormData } = useCampaignJoin();
  const logo = campaign?.campaignLogo ?? campaign?.ownerOrganization.logo;

  const shouldNavbarClose = useMemo(() => {
    if (router.asPath === routes.welcome) return true;
    if (router.asPath === routes.stravaConnect) return true;

    if (modules.tickets) return router.asPath === routes.tickets;
    if (modules.team) return router.asPath === routes.teams;
    if (modules.fundraiser) return router.asPath === routes.fundraiserCreate;

    return false;
  }, [router.asPath, routes, modules]);

  useCustomTheme({
    primary: campaign?.primaryColor,
    secondary: campaign?.accentColor,
  });

  // Reset form data when unmounting the layout
  useEffect(() => resetFormData, [resetFormData]);

  if (!campaign) return loading ? null : <NotFoundPage />;
  return (
    <WorkflowLayout
      backAction={shouldNavbarClose ? 'close' : 'back'}
      onBack={shouldNavbarClose ? () => onNavigate('exit') : router.back}
      title={title}
      logo={logo}
      logoFallbackText={campaign.ownerOrganization.name}
    >
      <div className="sm:max-w-lg sm:mx-auto flex-1 flex flex-col w-full -mt-8 sm:-mt-6">
        {children}
      </div>
    </WorkflowLayout>
  );
};

CampaignCheckoutLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

CampaignCheckoutLayout.defaultProps = {
  children: null,
  title: null,
};

export default CampaignCheckoutLayout;
